import '@fortawesome/fontawesome';
import '@fortawesome/fontawesome-free-brands';
import '@fortawesome/fontawesome-free-solid';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router'
import { NotFoundPage } from '../notFoundPage';
import Home from '../routes/home';
import homeDe from '../routes/homeDe';
import HomeRu from '../routes/homeRu';
import './App.css';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/ru" component={HomeRu}/>
          <Route exact path="/de" component={homeDe}/>
          <Route component={NotFoundPage}/>
        </Switch>
      </div>
    );
  }

  componentDidMount() {
  }
}

function mapStateToProps(_state) {
  return {};
}

const connectedApp = withRouter(connect(mapStateToProps)(App));
export { connectedApp as App };

